var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from '../axiosClient';
import { keysToSnake } from 'utils/converter';
export var getKycUser = function (iss) { return axios.get("/kyc/user/".concat(iss)); };
export var updateKycUser = function (iss, data) { return axios.put("/kyc/user/".concat(iss), keysToSnake(data)); };
export var getKycUserAnswer = function (iss) { return axios.get("/kyc/user_answer/".concat(iss)); };
export var updateKycUserAnswer = function (iss, answers) { return axios.put("/kyc/user_answer/".concat(iss), answers); };
export var getKycFileUser = function (iss) { return axios.get('/kyc/file_user', { params: { iss_user: iss } }); };
export var uploadKycFileUser = function (file) { return axios.post('/kyc/file_user', file); };
export var getKycEntityBySiren = function (siren, iss) { return axios.get("/kyc/entity/".concat(siren), { params: { iss_user: iss } }); };
export var updateKycEntityBySiren = function (siren, data, iss) { return axios.put("/kyc/entity/".concat(siren), __assign(__assign({}, data), { iss_user: iss }), { params: { iss_user: iss } }); };
export var getFileEntityBySiren = function (siren, iss) { return axios.get('/kyc/file_entity', { params: { siren: siren, iss_user: iss } }); };
export var uploadFileEntity = function (formData, siren, iss) { return axios.post('/kyc/file_entity', formData, { params: { siren: siren, iss_user: iss } }); };
